function mobilityOfferExists(mobilityOffer) {
  if (!mobilityOffer) {
    return false;
  }

  const {
    updatedAt, updatedBy, verified, ...rest 
  } = mobilityOffer;

  return !!Object.keys(rest).length;
}

export {
  mobilityOfferExists,
};